import Noty from 'noty'
import { NOTIFICATION_GROUPS } from '../_constants/notifications.constants'
import { formatCase } from 'xen/helpers'

export const showNotification = (message, type, options = {}) => {
  new Noty({
    layout: 'topRight',
    type: type,
    text: message,
    timeout: 4000,
    ...options,
  }).show()
}

export const getNotificationGroupLabel = (notification) => {
  const { name } = notification

  return NOTIFICATION_GROUPS[name]?.label || formatCase.sentence(name)
}
